new Vue({
    el: '#salary',
    data: {
        company: null,
        identityCode: null,
        contactPerson: null,
        phone: null,
        employees: null,
        branches: [],
        selectedBranch: null,

        intro: null,
        terms: null,

        isSubmited: false,
        result: false,
        resultMessage: null,
        sendingData: false,

        agreeTerms: false,
    },
    methods: {
        send: function (e) {
            e.preventDefault();
            var _this = this;
            if (_this.sendingData) { return; }
            _this.isSubmited = true;
            _this.resultMessage = null;
            valid = true;

            var formData = new FormData();
            formData.append('company', _this.company);
            formData.append('identityCode', _this.identityCode);
            formData.append('contactPerson', _this.contactPerson);
            formData.append('phone', _this.phone);
            formData.append('employees', _this.employees);
            formData.append('selectedBranch', _this.selectedBranch != null ? _this.selectedBranch.title : '');
            formData.append('captchaVal', $("#g-recaptcha-response").val());

            formData.append('languageId', window.languageId);

            var headerData = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };

            if (!_this.company ||
                !_this.identityCode ||
                !_this.contactPerson ||
                !_this.phone ||
                _this.selectedBranch == null ||
                !_this.agreeTerms ||
                _this.identityCode.length != 9) {
                valid = false;
            }
            if (valid) {
                _this.sendingData = true;
                axios.post('~/api/salary/send', formData, headerData).then(function (response) {
                    _this.result = response.data.success;
                    _this.resultMessage = response.data.message;
                }).catch(function (e) {
                    _this.result = false;
                    _this.resultMessage = window.errorPhrase;
                }).finally(function (e) {
                    _this.sendingData = false;
                })
            }
            _this.isSubmited = true;

            return false;
        }
    },
    mounted: function () {
        var _this = this;
        if (!!window.branches) {
            _this.branches = window.branches;
        }
    }
})